import React from "react"

const Icon = ({ primary = "#1A1B43", secondary = "url(#paint0_linear_1672_3440)" }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M29 3H24C23.45 3 23 3.45 23 4V8.74L15.43 5.1C15.15 4.97 14.83 4.97 14.55 5.1L2.55002 11.11C2.21002 11.28 1.99002 11.64 2.00002 12.02C2.01002 12.4 2.24002 12.75 2.59002 12.91L14.65 18.38C14.78 18.44 14.92 18.47 15.06 18.47C15.21 18.47 15.36 18.44 15.5 18.37L17.74 17.26C18.24 17.01 18.44 16.41 18.19 15.92C17.94 15.43 17.35 15.22 16.85 15.47L15.03 16.37L5.31002 11.96L14.99 7.12L22.98 10.96V20.42L15.1 24.87L7.00002 20.63V17.01C7.00002 16.46 6.55002 16.01 6.00002 16.01C5.45002 16.01 5.00002 16.46 5.00002 17.01V21.24C5.00002 21.61 5.21002 21.95 5.54002 22.13L14.65 26.9C14.8 26.98 14.95 27.01 15.11 27.01C15.28 27.01 15.45 26.97 15.6 26.88L22.98 22.72V23.91C22.98 24.09 23.03 24.27 23.13 24.43L25.63 28.53C25.81 28.83 26.14 29.01 26.48 29.01C26.82 29.01 27.15 28.83 27.33 28.53L29.83 24.43C29.93 24.27 29.98 24.09 29.98 23.91V4C29.98 3.45 29.53 3 28.98 3H29ZM28 23.62L26.5 26.08L25 23.62V5H28V23.62Z"
      fill={primary}
    />
    <path
      d="M20 19.9998C19.45 19.9998 19 19.5498 19 18.9998V14.6198L15.55 12.8998C15.06 12.6498 14.86 12.0498 15.1 11.5598C15.35 11.0698 15.95 10.8698 16.44 11.1098L20.44 13.1098C20.78 13.2798 20.99 13.6298 20.99 13.9998V18.9998C20.99 19.5498 20.54 19.9998 19.99 19.9998H20Z"
      fill={secondary}
    />
    <defs>
      <linearGradient
        id="paint0_linear_1672_3440"
        x1="20.99"
        y1="11.0083"
        x2="20.99"
        y2="19.9998"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FD9317" />
        <stop offset="1" stopColor="#F63B3B" />
      </linearGradient>
    </defs>
  </svg>
)

export default Icon
